module.exports = __webpack_public_path__ + "static/media/221-Milo-Monolog_ID_2.7537d5dc.mp3";